import { Box, Paper, Stack, Typography } from "@mui/material";
import BackButton from "@quest_editor/components/Buttons/BackButton";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@quest_editor/components/Breadcrumb";
import PromotionTypeChip from "@quest_editor/components/Chips/PromotionTypeChip";
import PromotionStatusChip from "@quest_editor/components/Chips/PromotionStatusChip";
import { useQuest, usePromotion } from "@quest_editor/mocks";

const QuestAnalytics = () => {
  const { t } = useTranslation("questEditor");
  const { id: questId } = useParams<{ id: string }>();

  const { data: questData } = useQuest(questId);
  const quest = questData?.quest;

  const { data: promotionData } = usePromotion(quest?.promotionId);
  const promotion = promotionData?.promotion;

  // TODO: 実際の簡易集計/グラフ表示URLに置き換える
  const analyticsUrl = "about:blank";

  if (!quest || !promotion) {
    return <Typography>{t("common.label.not_found")}</Typography>;
  }

  return (
    <Stack direction="column" spacing={3} sx={{ flex: 1, minHeight: 0 }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Stack direction="column" spacing={2} alignItems="flex-start">
          <Breadcrumb items={[{ label: promotion.name, to: `/quest_editor/promotion/${promotion.id}` }, { label: quest.name }]} />
          <Stack direction="row" spacing={1}>
            <PromotionTypeChip type={promotion.type} />
            <PromotionStatusChip status={promotion.status} />
          </Stack>
        </Stack>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          border: 1,
          borderColor: "divider",
          flex: 1,
          minHeight: 500,
          overflow: "hidden",
        }}
      >
        <Box
          component="iframe"
          src={analyticsUrl}
          title="Quest Analytics"
          sx={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Paper>

      <BackButton
        component={Link}
        to={`/quest_editor/quest/${quest.id}`}
        sx={{ alignSelf: "flex-start" }}
      >
        {t("quest_analytics.button.back")}
      </BackButton>
    </Stack>
  );
};

export default QuestAnalytics;
